<template>
  <div class="dynamic_package">

    <changeNav/>
    <Carousel>
      <template slot="titleTxt">
				<div class="title-box">
					<img src="~@/assets/image/product.png" alt="" width="120" height="23" class="title-img" />
					<span class="title-txt">Products & solutions</span>
				</div>
			</template>
    </Carousel>
    <!--导航开始-->
    <Breadcrumb/>
    <!--导航开始结束-->


    <!--新闻动态开始-->
    <div class="dynamic_con">
        <div class="dynamic_nav clearfix">

          <div class="tab">
            <a class="item" v-for="(item,index) in ProductsCategory" :key ="index" @click="chageData(item.code,index)" :class="{on:index==currentIndex }">{{item.name}}</a>
          </div>
           <div class="dynamic_new">
             <div v-show="noData">当前没有数据</div>
             <ul class="dynamic_list clearfix" v-show="!noData">
                 <li class="clearfix animated bounceIn" v-for="(item,index) in currentDynimicProduct" :key = "index" @click="goProductDetail(item.id)">
                 <div class="dynamic_img">
                   <img :src="item.imageUrl" alt="" width="255" height="180"/>
                 </div>
                 <div class="dynamic_item">
                   <div class="dynamic_item_title">{{item.title}}</div>
                   <div class="dynamic_item_info">{{item.content}}</div>
                   <div class="dynamic_item_data">{{item.newsDate | data(".")}}</div>
                 </div>
               </li>
             </ul>
           </div>
        </div>
    </div>
    <!--新闻动态结束-->
  </div>
</template>

<script>
  import  changeNav from '@/components/changeNav.vue';
  import  Carousel from '@/components/Carousel.vue';
  import  Breadcrumb from '@/components/Breadcrumb.vue';
  import { 
    GetProductCategoryList,
    GetProductsDynamicList 
  } from './Product.model';

    export default {
        name: "Dynamic",
        components:{
          changeNav,
          Carousel,
          Breadcrumb
        },
      metaInfo: {
        title: '福建省越盛智能科技有限公司', // set a title
        meta: [{                 // set meta
          name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
          content: '新闻动态'
        }],
        link: [{                 // set link
          rel: 'asstes',
          href: 'http://www.fjyszn.com/'
        }]
      },
       data(){
        return {
          ProductsCategory:[],
          currentDynimicProduct:[],
          currentIndex:0,
          noData:false
        }
      },
      async mounted(){
         let CategoryData = await  GetProductCategoryList();
         this.ProductsCategory =  CategoryData.data.list;
         this.chageData("productTypeCode1",0);
       },

      methods:{
           async chageData(type,index){
             this.currentIndex = index;
             let param ={
                 page:1,
                 limit:0,
                 typeCode:type
              };
             let dynimicData = await  GetProductsDynamicList(param);
             this.currentDynimicProduct = dynimicData.data.list;
             this.noData = false;
              if(this.currentDynimicProduct == 0){
                 this.noData = true;
              }
           },
        goProductDetail(productId){
          this.$router.push({ path: '/ProductDetail', query: { plan: productId }});
        }
      }
    }
</script>

<style scoped lang="less">
  .title-box{
    text-align: left;
    height: 80px;
    line-height: 80px;
    img{
      vertical-align: middle;
    }
    span{
      vertical-align: middle;
      color: #CCC;
      font-size: 16px;
      display: inline-block;
      margin-left: 15px;
      line-height: 24px;
      margin-top: 10px;
    }
  }


  .dynamic_package{
    .el-carousel{
       width: 100%!important;
    }
  }
  .dynamic_package{

  }
  .dynamic_con{
     width: 1240px;
     margin: 0px auto 102px;
  }
  .tab{
    width: 190px;
    float: left;
    margin-right: 20px;
    position: relative;
    margin-top: 1px;
    &::before{
      content: " ";
      width: 100%;
      height: 1px;
      background-color: #E6E6E6;
      transform: scaleY(0.5);
      position: absolute;
      left: 0;
      top: -1px;
    }
  .item{
    font-size:14px;
    color: #B3B3B3;
    display: block;
    line-height: 54px;
    width:190px;
    height:54px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 0px 0px rgba(230,230,230,1);
    text-decoration: none;
    cursor: pointer;
     text-align: left;
      text-indent: 55px;
      position: relative;
    &:first-child{

    }
    &:hover{
       color:#39B2EC;
    }
    &::after{
      content: " ";
      width: 100%;
      height: 1px;
      background-color: #E6E6E6;
      transform: scaleY(0.5);
      position: absolute;
      left: 0;
      bottom: 0;
    }
   }
   .item.on{
     position: relative;
     color: #39B2EC;
     &::before{
       content: " ";
       display: block;
       width: 6px;
       height: 6px;
       background: #39b2ec;
       position: absolute;
       top: 25px;
       left: 38px;
       border-radius: 50%;
     }
   }
  }
  .dynamic_new{
     float: left;
     width: 1030px;
    .dynamic_list{
      li{
         cursor: pointer;
      }

    }
    .dynamic_img{
       float: left;
    }
    .dynamic_item{
       float: left;
       width: 733px;
       border:1px solid #E6E6E6;
       padding: 20px;
      margin-bottom: 18px;
       border-left: none;
      text-align: left;
      overflow: hidden;
      .dynamic_item_title{
        font-size:20px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .dynamic_item_info{
        font-size:14px;
         margin-top: 15px;
         height: 48px;
        font-weight:400;
        color:rgba(179,179,179,1);
        line-height:26px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .dynamic_item_data{
        font-size:14px;
        margin-top: 20px;
        margin-bottom: 11px;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:20px;
      }



    }
  }


</style>
